webpackJsonp([18709288761271],{

/***/ 1649:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/people/sian-teasdale/","posts":[{"fields":{"slug":"/news/introducing-sian-teasdale/","author":{"id":"/opt/build/repo/src/pages/people/sian-teasdale.md absPath of file >>> MarkdownRemark"}},"frontmatter":{"title":"Introducing... Sian Teasdale","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/sian-87bec76936d6d29a935278c3722c13a4.png"}}},"original":"/img/sian.png"},"category":"Culture"}}]},"frontmatter":{"title":"Sian Teasdale"}}}]}},"pathContext":{"author":"/people/sian-teasdale/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---authors-sian-teasdale-f58712b4e18e8cb8a638.js